import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "row pt-sm-9 pt-7 pb-5",
    id: "scarabFake"
};
const _hoisted_2 = {
    key: 0,
    class: "col-12 text-center mb-lg-45 mb-3"
};
const _hoisted_3 = { class: "h2-responsive" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = ["data-scarabitem"];
const _hoisted_6 = {
    key: 1,
    class: "col-12 text-center"
};
const _hoisted_7 = {
    key: 1,
    class: "row no-gutters border bg-brand_beige_light mt-sm-9 mt-7 mb-5 position-relative"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_product_box = _resolveComponent("product-box");
    return (_ctx.recos !== null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.headline || _ctx.subHeadline)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.headline), 1),
                    (_ctx.subHeadline)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.subHeadline), 1))
                        : _createCommentVNode("", true)
                ]))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentRecos, (product, index) => {
                return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "emarsysBoxWrapper col-xl-3 col-lg-6 col-sm-6 mt-sm-3 mt-2 mb-lg-3 mb-md-1 mb-2 px-lg-3 px-md-2 px-2"
                }, [
                    _createElementVNode("span", {
                        "data-scarabitem": product.modelId
                    }, [
                        _createVNode(_component_product_box, {
                            product: product,
                            "is-model-box-view": true
                        }, null, 8, ["product"])
                    ], 8, _hoisted_5)
                ]));
            }), 128)),
            (!_ctx.noButtons)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] =
                            //@ts-ignore
                            (...args) => (_ctx.loadPrevious && _ctx.loadPrevious(...args))),
                        class: _normalizeClass(["emarsysButtons m-4 font4-responsive", { emarsysButtonDisabled: _ctx.leftButtonDisabled }]),
                        title: "zurück"
                    }, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("i", { class: "icon-arrow-prev" }, null, -1)
                        ]))], 2),
                    _createElementVNode("button", {
                        onClick: _cache[1] || (_cache[1] =
                            //@ts-ignore
                            (...args) => (_ctx.loadNext && _ctx.loadNext(...args))),
                        class: _normalizeClass(["emarsysButtons m-4 font4-responsive", { emarsysButtonDisabled: _ctx.rightButtonDisabled }]),
                        title: "weiter"
                    }, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("i", { class: "icon-arrow-next" }, null, -1)
                        ]))], 2)
                ]))
                : _createCommentVNode("", true)
        ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[4] || (_cache[4] = [
                _createStaticVNode("<img src=\"/images/_new_brand/cookiebanner_swooop.png\" class=\"mr-2 position-absolute\" alt=\"Banner\" style=\"bottom:0;right:0;z-index:0;max-height:100%;max-width:100%;\" data-v-10dcc86d><div class=\"col-lg-7 px-md-5 px-3 pt-3 pb-md-3 pb-2\" data-v-10dcc86d><img src=\"/images/_new_brand/cookies_small.png\" class=\"mr-2 pb-2\" alt=\"Cookies\" style=\"max-height:70px;max-width:70px;object-fit:contain;\" data-v-10dcc86d><p class=\"font-boucle h1-responsive\" data-v-10dcc86d>KEKSE!</p><p class=\"h3-responsive p1 pb-2\" data-v-10dcc86d> Wir würden Dir hier gerne Deine <br data-v-10dcc86d><span class=\"font-boucle font-weight-normal\" data-v-10dcc86d>Produkt­empfehlungen</span> zeigen. </p><p class=\"font6-responsive\" data-v-10dcc86d> Damit Du hier Produkte angezeigt bekommst, die Dich interessieren, setzen wir Technologien wie Cookies ein. </p></div>", 2),
                _createElementVNode("div", {
                    class: "col-lg-5 px-md-5 px-3 pt-md-5 pt-4 pb-md-5 pb-3 text-center",
                    style: { "display": "flex", "justify-content": "center", "align-items": "center" }
                }, [
                    _createElementVNode("div", { class: "contentWrapper" }, [
                        _createElementVNode("p", { class: "h4-responsive text-center" }, [
                            _createTextVNode(" Du möchtest Deine "),
                            _createElementVNode("br"),
                            _createElementVNode("span", { class: "font-boucle font-weight-normal" }, "Cookie"),
                            _createTextVNode(" Einstellungen "),
                            _createElementVNode("br"),
                            _createTextVNode(" nochmal "),
                            _createElementVNode("span", { class: "font-boucle font-weight-normal" }, "ändern"),
                            _createTextVNode(" ? ")
                        ]),
                        _createElementVNode("button", {
                            class: "buttonBase buttonBlue",
                            style: { "width": "100%", "max-width": "300px" },
                            onclick: "document.getElementById('cookie_consent_banner').style = 'z-index:999999999;';"
                        }, " Hier klicken! ")
                    ])
                ], -1)
            ]))]));
}
